import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../_services';
import { IChangeCallback } from '../../_entities';
import { ContractBase } from "./contract.base";

@Component({
    selector: 'contract-break-clause',
    template: require('./contract-break-clause.template.html')
})
export class ContractBreakClauseComponent extends ContractBase implements OnInit {

    constructor(
        protected readonly contractService: ContractService) {
        super(contractService);
    }

	yesNoOptions = [{ id: false, name: 'No' }, { id: true, name: 'Yes' }];

	 getYearsToBreakOption(breakClause): string {
       
        return breakClause != null && breakClause.yearsToBreakOption != null ? breakClause.yearsToBreakOption : "-";
    }

	 getMonthsToBreakOption(breakClause): string {
     
        return breakClause != null && breakClause.monthsToBreakOption != null ? breakClause.monthsToBreakOption : "-";
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }


	 onAddBreakClause(e) {
		 const contractId = this.contract.id;
		 this.contractService.addBreakClause(contractId).then((breakClause) => {
			 this.contract.breakClauses.push(breakClause);
			 e.resolve();
		 }).catch((err) => {
			 e.reject(err);
		 });
	 }

	onDeleteBreakClause(id, e: IChangeCallback<any>) {
		this.contractService.deleteBreakClause(id).then(() => {
			this.contract.breakClauses = this.contract.breakClauses.filter(x => x.id !== id);
			e.resolve();
		}).catch(e.reject);
	}


	 onChangeBreakClause(id, e: IChangeCallback<any>) {
		 this.contractService.patchBreakClause(id, e.id, e.newValue).then((breakClause) => {
			 this.contract.breakClauses = this.contract.breakClauses.map(x => x.id == breakClause.id ? breakClause : x);
			 e.resolve();
		 }).catch(e.reject);
	 }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-break-clause.component.ts